import React from 'react';
import { ArrowRight, CreditCard, Crown, Sparkles } from 'lucide-react';
import { FREE_VENUE_FEATURES, PREMIUM_VENUE_FEATURES, isPremiumVenueProfile } from './venueFeatureConfig';

const VenueAccessBanner = ({
    club,
    clubId,
    navigate,
    premiumOnlyFeature = false,
    featureLabel = 'This area'
}) => {
    const isPremiumVenue = isPremiumVenueProfile(club);

    return (
        <div className={`venue-access-banner ${isPremiumVenue ? 'premium' : 'free'}`}>
            <div className="venue-access-banner-head">
                <div className={`venue-access-banner-badge ${isPremiumVenue ? 'premium' : 'free'}`}>
                    {isPremiumVenue ? <Crown size={16} /> : <CreditCard size={16} />}
                    <span>{isPremiumVenue ? 'Premium Venue' : 'Free Venue'}</span>
                </div>
                {!isPremiumVenue && premiumOnlyFeature ? (
                    <div className="venue-access-banner-tag">
                        <Sparkles size={14} />
                        <span>{featureLabel} is a Premium venue feature</span>
                    </div>
                ) : null}
            </div>

            <div className="venue-access-banner-body">
                <div>
                    <h3>{isPremiumVenue ? 'Premium venue features are active' : 'You are currently on the Free venue plan'}</h3>
                    <p>
                        {isPremiumVenue
                            ? 'This venue can access premium venue management areas and the richer public venue presentation.'
                            : 'Free venues can manage the core venue profile, members, stands, and perks. Upgrade to Premium to unlock events, media, till/POS, communications, and marketplace / shopfront tools.'}
                    </p>
                </div>

                <div className="venue-access-banner-lists">
                    <div>
                        <span>Free Venue Features</span>
                        <ul>
                            {FREE_VENUE_FEATURES.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <span>Premium Venue Features</span>
                        <ul>
                            {PREMIUM_VENUE_FEATURES.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {!isPremiumVenue ? (
                    <button
                        type="button"
                        className="manage-section-add-btn"
                        onClick={() => navigate(`/dashboard/club/${clubId}/plan`)}
                    >
                        Upgrade
                        <ArrowRight size={16} />
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default VenueAccessBanner;
